var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      staticClass: "row",
      staticStyle: {
        "padding-top": "20px",
        "padding-left": "15px",
        "padding-right": "15px",
      },
    }),
    _c(
      "div",
      {
        staticClass: "row",
        staticStyle: {
          "padding-top": "20px",
          "padding-left": "15px",
          "padding-right": "16px",
        },
      },
      [
        _c("div", { staticClass: "row p-t10-b10" }, [
          _c(
            "div",
            { staticClass: "col-sm-offset-4 col-md-4 col-sm-4 col-xs-12" },
            [
              _vm.kitClassSummary.classCode === "Not Applicable"
                ? _c("div", { staticClass: "class-heading-notes" }, [
                    _vm.prodClassCriteria.device_name != null
                      ? _c(
                          "span",
                          { staticClass: "class-heading-notes-style" },
                          [_vm._v(_vm._s(_vm.prodClassCriteria.device_name))]
                        )
                      : _vm._e(),
                    _vm._v(
                      "does not appear to be an IVD according to the IVDR. "
                    ),
                  ])
                : _c("div", { staticClass: "class-heading-notes" }, [
                    _vm._v(" Based on the inputs you provided the "),
                    _c("span", { staticClass: "class-heading-notes-style" }, [
                      _vm._v(_vm._s(_vm.prodClassCriteria.country)),
                    ]),
                    _vm._v(" classification "),
                    _vm.prodClassCriteria.device_name != null
                      ? _c(
                          "span",
                          { staticClass: "class-heading-notes-style" },
                          [
                            _vm._v(
                              "for " + _vm._s(_vm.prodClassCriteria.device_name)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" appears to be: "),
                  ]),
            ]
          ),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "row p-t10-b10" }, [
          _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-12" }, [
            _vm.kitClassSummary.classCode === "Not Applicable"
              ? _c("div", { staticClass: "row p-t10-b10" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "row p-t10-b10" }, [
                    _c("div", {
                      staticClass: "col-lg-4 col-md-4 col-sm-8 col-xs-12",
                    }),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-8 col-xs-12" },
                      [
                        _vm.kitClassSummary.classCode != "Not Applicable" &&
                        _vm.kitClassSummary.classCode &&
                        _vm.kitClassSummary.classCode.length > 0
                          ? _c("div", { staticClass: "circle" }, [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.kitClassSummary.classCodeSfx
                                  ),
                                },
                              }),
                            ])
                          : _vm.kitClassSummary.classCode ===
                              "Not Applicable" &&
                            _vm.kitClassSummary.classCode &&
                            _vm.kitClassSummary.classCode.length > 0
                          ? _c("div", { staticClass: "circle" }, [
                              _vm._v(" NA "),
                            ])
                          : _c("div", { staticClass: "circle" }, [
                              _c("span", [_vm._v("NA")]),
                            ]),
                      ]
                    ),
                    _c("div", {
                      staticClass: "col-lg-4 col-md-4 col-sm-8 col-xs-12",
                    }),
                  ]),
                ])
              : _c("div", [
                  _vm._m(2),
                  _c("div", { staticClass: "row p-t10-b10" }, [
                    _c("div", {
                      staticClass: "col-lg-4 col-md-4 col-sm-8 col-xs-12",
                    }),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-8 col-xs-12" },
                      [
                        _c("div", { staticClass: "circle" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.kitClassSummary.classCode
                                  ? _vm.kitClassSummary.classCodeSfx
                                  : "NA"
                              ),
                            },
                          }),
                        ]),
                      ]
                    ),
                    _c("div", {
                      staticClass: "col-lg-4 col-md-4 col-sm-8 col-xs-12",
                    }),
                  ]),
                ]),
          ]),
          _c("div", { staticClass: "col-md-7 col-sm-7 col-xs-12" }, [
            _c("div", { staticClass: "row" }),
            _c("div", {
              staticClass: "class-notes",
              domProps: { innerHTML: _vm._s(_vm.kitClassSummary.classNotes) },
            }),
          ]),
          _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-2" }),
        ]),
        _vm.prodClassCriteria.country === "EU IVDR" &&
        _vm.pageConfig.IVDRKitClassificationNote
          ? _c("div", { staticClass: "row p-t10-b10" }, [
              _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-1" }),
              _c(
                "div",
                { staticClass: "col-md-7 col-sm-7 col-xs-11 class-notes-ivdr" },
                [
                  _c("div", { staticClass: "margin_ivdr_note" }, [
                    _c("span", { staticClass: "note_caption" }, [
                      _vm._v("NOTE:"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.pageConfig.IVDRKitClassificationNote) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-1" }),
            ])
          : _vm._e(),
        _vm._m(3),
      ]
    ),
    _vm.prodClassCriteria.workflowResponseMap.size
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-1" }),
          _vm._m(4),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-1" }),
        ])
      : _vm._e(),
    _vm.prodClassCriteria.workflowResponseMap.size
      ? _c("div", { staticClass: "row margin_ivdr_comp" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-1" }),
          _vm._m(5),
          _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-1" }),
        ])
      : _vm._e(),
    _vm.prodClassCriteria.workflowResponseMap.size
      ? _c("div", { staticClass: "row margin_ivdr_comp" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-1" }),
          _c("div", { staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-10" }, [
            _c(
              "div",
              { staticClass: "class-heading-notes child-data-style" },
              _vm._l(
                _vm.prodClassCriteria.workflowResponseMap,
                function (comp, key, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "row class-heading-notes margin_ivdr_comp",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-5 col-md-5 col-sm-4 col-xs-5 class-notes child-data-style",
                        },
                        [_vm._v(_vm._s(comp[1].name))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-5 col-md-5 col-sm-4 col-xs-5 class-notes child-data-style",
                        },
                        [
                          comp[1].classCode
                            ? _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(comp[1].classCode),
                                },
                              })
                            : _c("span", {
                                domProps: {
                                  innerHTML: _vm._s("Not Applicable"),
                                },
                              }),
                        ]
                      ),
                    ]
                  )
                }
              ),
              0
            ),
          ]),
          _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-10" }),
        ])
      : _vm._e(),
    _vm.prodClassCriteria.country === "EU IVDR"
      ? _c("div", [
          _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-12 col-md-12 col-sm-12 col-xs-12 heading",
                  },
                  [_vm._v("For Purchase")]
                ),
              ])
            : _vm._e(),
          _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true &&
          _vm.kitClassSummary.classCodePfx &&
          _vm.kitClassSummary.classCodePfx.length > 0
            ? _c("div", { staticClass: "row alert-detail p-t10-b10" }, [
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block prev-slide emergo-blue-button float-right m-t5",
                        on: {
                          click:
                            this.$parent
                              .checkMarketPlaceWrapperForRationaleReport,
                        },
                      },
                      [_vm._v("Rationale Report")]
                    ),
                  ]
                ),
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
              ])
            : _vm._e(),
          _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true
            ? _c("div", { staticClass: "row alert-detail p-t10-b10" }, [
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-block prev-slide emergo-blue-button float-right",
                        attrs: { id: "mktPlaceProdClassTwo" },
                        on: { click: _vm.regPathwayRouterWrapper },
                      },
                      [_vm._v("Regulatory Essentials Report")]
                    ),
                  ]
                ),
                _c("div", {
                  staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12",
                }),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.prodClassCriteria.compositeArrayWrapper.classFoundFlag == true &&
    _vm.prodClassCriteria.current_slide_number === 3
      ? _c("div", { staticClass: "disclaimer margin_top_bottom_15" }, [
          _c("br"),
          _vm._v(
            "Disclaimer:This assesment is not intended to replace an in-depth analysis of your company's circumstances, replace a gap analysis or discourage or prevent you or your company from taking appropriate and timely action. Reports are general in nature, not individualized to any particular product or manufacturer, and do not constitute a definitive or comprehensive statement of regulatory information. Emergo by UL is separately available to provide consulting services with respect to the regulatory processes applicable to particular products in specific markets. "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row p-t10-b10" }, [
      _c("div", { staticClass: "col-md-10 col-sm-10 col-xs-10" }, [
        _c("div", { staticClass: "hr-class" }, [_c("hr")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row p-t10-b10" }, [
      _c("div", { staticClass: "col-lg-5 col-md-5 col-sm-1 col-xs-1" }),
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-10 col-xs-10" }, [
        _c("span", { staticClass: "class-heading-notes class-code-banner" }, [
          _vm._v("Class"),
        ]),
      ]),
      _c("div", { staticClass: "col-lg-5 col-md-5 col-sm-1 col-xs-1" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row p-t10-b10" }, [
      _c("div", { staticClass: "col-lg-5 col-md-5 col-sm-1 col-xs-1" }),
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-10 col-xs-10" }, [
        _c("span", { staticClass: "class-heading-notes class-code-banner" }, [
          _vm._v("Class"),
        ]),
      ]),
      _c("div", { staticClass: "col-lg-5 col-md-5 col-sm-1 col-xs-1" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-1" }),
      _c("div", { staticClass: "col-md-7 col-sm-7 col-xs-10" }, [
        _c("div", { staticClass: "hr-thin" }, [_c("hr")]),
      ]),
      _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-1" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-10" }, [
      _c(
        "div",
        {
          staticClass:
            "kit-comp-col-header kit-comp-details-heading child-data-style",
        },
        [_vm._v(" IVD Kit components details ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-10" }, [
      _c("div", { staticClass: "row comp_name kit-comp-col-header" }, [
        _c(
          "div",
          {
            staticClass: "col-lg-5 col-md-5 col-sm-4 col-xs-5 child-data-style",
          },
          [_vm._v("Component")]
        ),
        _c(
          "div",
          {
            staticClass: "col-lg-5 col-md-5 col-sm-4 col-xs-5 child-data-style",
          },
          [_vm._v("Class code")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }